import type { Dayjs } from "dayjs";
import Decimal from "decimal.js";

// 解析蓄積の先頭キー。2026-07-21 に 7/1 以降ぶんをバックフィル済み
// (isilon の GSM_gl アーカイブから再生成、実際の先頭は 6/30 21:36)。
// UIの6時間刻みは、この時刻より前を選択肢へ出さない。
export const GSL_ANALYSIS_START = "2026-06-30T21:36:00";

export function usesGslAnalysis(ft: Decimal) {
    // GSL予報にはFT000.0が無いため、FD=0も解析側を正規経路とする。
    return ft.lte(0);
}

export function gslTargetKey(initial: Dayjs, ft: Decimal) {
    const target = initial.add(Math.round(ft.toNumber() * 60), "minute");
    const deci = Math.round(target.minute() / 6);
    return {
        target,
        key: `${target.format("YYYYMMDD-HH")}.${deci}`,
    };
}

export function gslForecastKey(ft: Decimal) {
    return ft.toFixed(1).padStart(5, "0");
}
